/* eslint-disable consistent-return */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const useScreenRecorder = ({ options, audio = false }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [blob, setBlob] = useState(null);
  const [error, setError] = useState();
  const [mediaRecorder, setMediaRecorder] = useState();
  const [status, setStatus] = useState("permission-requested");
  const [streams, setStreams] = useState({ audio: null, screen: null });

  useEffect(() => {
    if (!mediaRecorder) return;
    mediaRecorder.ondataavailable = async (event) => {
      const url = window.URL.createObjectURL(event.data);
      setBlobUrl(url);
      setBlob(event.data);
      const base64String = await blobToBase64(event.data);
      console.log("Blob converted to base64:", base64String);
    };
  }, [mediaRecorder]);

  const requestMediaStream = async () => {
    try {
      const displayMedia = await navigator.mediaDevices.getDisplayMedia();
      let userMedia;
      if (audio) {
        try {
          userMedia = await navigator.mediaDevices.getUserMedia({ audio });
        } catch (audioError) {
          console.warn(
            "Audio permission denied or audio not available",
            audioError
          );
          // Proceed without audio
        }
      }
      const tracks = [
        ...(displayMedia?.getTracks() || []),
        ...(userMedia?.getTracks() || [])
      ];
      if (tracks) setStatus("idle");
      const stream = new MediaStream(tracks);
      const mediaRecorder1 = new MediaRecorder(stream, options);
      setMediaRecorder(mediaRecorder1);

      setStreams({
        audio: userMedia
          ? userMedia.getTracks().find((track) => {
              return track.kind === "audio";
            }) || null
          : null,
        screen: displayMedia
          ? displayMedia.getTracks().find((track) => {
              return track.kind === "video";
            }) || null
          : null
      });

      return mediaRecorder1;
    } catch (e) {
      setError(e);
      setStatus("error");
    }
  };

  const stopRecording = () => {
    if (!mediaRecorder) throw Error("No media stream!");
    mediaRecorder?.stop();

    setStatus("stopped");

    mediaRecorder.stream.getTracks().map((track) => {
      track.stop();
    });
    setMediaRecorder(null);
  };

  const startRecording = async () => {
    try {
      let recorder = mediaRecorder;
      if (!mediaRecorder) {
        recorder = await requestMediaStream();
      }
      recorder.start();
      setStatus("recording");
    } catch (e) {
      console.error("Error starting recording:", e);
      // Handle error as needed
    }
  };

  const pauseRecording = () => {
    if (!mediaRecorder) throw Error("No media stream!");
    mediaRecorder?.pause();
    setStatus("paused");
  };

  const resumeRecording = () => {
    if (!mediaRecorder) throw Error("No media stream!");
    mediaRecorder?.resume();
    setStatus("recording");
  };

  const resetRecording = () => {
    setBlobUrl(null);
    setError(null);
    setMediaRecorder(null);
    setStatus("idle");
  };

  return {
    blob,
    blobUrl,
    error,
    pauseRecording,
    resetRecording,
    resumeRecording,
    startRecording,
    status,
    setStatus,
    stopRecording,
    streams
  };
};

export default useScreenRecorder;
